export default {
  data () {
    return {
      showRequestResetPasscodeConfirmModalFlag: false,
      isRequestingResetPasscode: false
    }
  },
  computed: {
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId']
    }
  },
  methods: {
    showRequestResetPasscodeConfirmModal () {
      this.showRequestResetPasscodeConfirmModalFlag = true
    },
    async requestResetPasscode () {
      this.isRequestingResetPasscode = true
      await this.$store.dispatch('UsersStore/requestResetPasscode', this.loggedUserId)
      this.isRequestingResetPasscode = false
    }
  }
}
